module.exports = __webpack_public_path__ + "img/11.589bcd27.jpeg";